import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { Subject, Subscription, firstValueFrom, take } from "rxjs";
import { filter } from 'rxjs/operators';
import { Router } from "@angular/router";
import { SessionService } from "../../shared/services/Session.service";
import { SignalRService } from "../../shared/services/Signal-R.service";
import { SignalUser } from "../../shared/models/SignalUser/SignalUser";
import { EnumFolderPaths } from "../../shared/helpers/enums/EnumFolderPaths";
import { UrlSasDTO } from "../../shared/models/AzureStorage/UrlSasDTO";
import { SystemNotificationCatalogService } from "../../shared/features/system-notification/services/systemNotificationCatalog.service";
import { AuthService } from "../../authmanagement/services/Auth.service";
import { NotificationService } from "../../notifications/services/Notification.service";
import { TutorialService } from "../../shared/features/tutorial/services/tutorial.service";
import { EncriptionService } from "../../shared/services/Encription.service";
import { AzureStorageService } from "../../shared/services/ServiceCatalogEncapsulators/AzureStorage.service";
import { EnumsService } from "../../shared/services/ServiceCatalogEncapsulators/Enums.service";
import { PermissionsService } from "../../shared/services/ServiceCatalogEncapsulators/Permissions.service";
import { SignalUserService } from "../../shared/services/ServiceCatalogEncapsulators/Signal-User.service";
import { UserConfigurationsService } from "../../shared/services/ServiceCatalogEncapsulators/UserConfigurations.service";
import { ViewsService } from "../../shared/services/ServiceCatalogEncapsulators/Views.service";
import { LocationCategoriesService } from "../../locations-map/services/LocationCategories.service";
import { ImageCacheService } from "../../shared/services/ImageCache.service";
import { LocationsService } from "../../locations-map/services/Locations.service";
import { LocationsMapService } from "../../locations-map/services/Locations-Map.service";
import { CitronellaExternalAPIService } from "../../shared/services/External API/CitronellaExternalAPI.service";
import { CitronellaActionsService } from "../../shared/services/ServiceCatalogEncapsulators/CitronellaActions.service";
import { ThirdPartySettingsService } from "../../shared/services/ServiceCatalogEncapsulators/ThirdPartySettings.service";
import { CallbackAPIService } from "../../shared/services/API/CallbackAPI.service";
import { WebCallbackDTO } from "../../shared/models/CallBack/WebCallbackDTO";

@Injectable({
  providedIn: "root",
})
export class CallBackService {
  configUrl: string;
  public isReloading: boolean = false;
  public clientes: any = [];
  isMapix: boolean;
  IsAdmin: boolean = false;
  IsSuperuser: boolean = false;
  returnRoles = {
    IsAdmin: false,
    IsSuperuser: false
  };
  isCallBackActive: boolean = false;

  SignalUser: SignalUser = new SignalUser();

  private rolItem$: Subject<string[]> = new Subject();
  private clientes$: Subject<any> = new Subject();
  private clienteDisplay$: Subject<string> = new Subject();
  private views$: Subject<string[]> = new Subject();
  private connectionIdSub: Subscription;

  constructor(
    private callbackAPIService: CallbackAPIService,
    private UserConfigurationService: UserConfigurationsService,
    private router: Router,
    private authService: AuthService,
    private sessionService: SessionService,
    private permissionService: PermissionsService,
    private encriptionService: EncriptionService,
    private viewService: ViewsService,
    private signalUserService: SignalUserService,
    private signalRService: SignalRService,
    private azureStorageService: AzureStorageService,
    private locationCategoriesService: LocationCategoriesService,
    private tutorialService: TutorialService,
    private enumCatalogService: EnumsService,
    private systemNotificationService: SystemNotificationCatalogService,
    private notificationService: NotificationService,
    private imageCache: ImageCacheService,
    private locationsService: LocationsService,
    private locationsMapService: LocationsMapService,
    private thirdPartySettingsService: ThirdPartySettingsService,
    private citronellaExternalAPIService: CitronellaExternalAPIService,
  ) {
    this.configUrl = environment.host;
    this.checkingURL();
    // Subscribe to ConnectionId changes so we can subscribe the SignalUser as soon as an id is available
    this.connectionIdSub = this.signalRService.connectionId$
      .pipe(filter((id) => id != null && id !== ""))
      .subscribe((id) => {
        // assign to local SignalUser and subscribe
        try {
          this.SignalUser.ConnectionId = id as string;
          this.subscribeSignalUser();
        } catch (e) {
          console.error('Error subscribing SignalUser on ConnectionId change', e);
        }
      });
  }

  setRolItem(resp) {
    this.rolItem$.next(resp);
  }

  setClientes(resp) {
    this.clientes$.next(resp);
  }

  setClienteDisplay(resp) {
    this.clienteDisplay$.next(resp);
  }

  setViews(resp) {
    this.views$.next(resp);
  }

  getRolItem() {
    return this.rolItem$.asObservable();
  }

  getClientes() {
    return this.clientes$.asObservable();
  }

  getClienteDisplay() {
    return this.clienteDisplay$.asObservable();
  }

  getViews() {
    return this.views$.asObservable();
  }

  async isNeededCallback() {
    if (!(this.router.url.includes("login"))) {
      //revisa si el usuario tiene los datos de localstorgae
      if (
        localStorage.getItem("userRol") == "" ||
        localStorage.getItem("userRol") == null ||
        localStorage.getItem("userRol").length == 0 ||
        localStorage.getItem("permissions") == "" ||
        // localStorage.getItem("permissions").length == 0 ||
        localStorage.getItem("permissions") == null ||
        localStorage.getItem("listaCategorias") == null ||
        localStorage.getItem("listaCategorias") == "" ||
        localStorage.getItem("UrlList") == null ||
        localStorage.getItem("UrlList") == "" 
      ){
        if (localStorage.getItem("token")==null || localStorage.getItem("token")=="")
          this.authService.Logout();  
        
        if (!this.isCallBackActive) {
          await this.dataCallbackOneCall(false);
          this.assignNavbarValues();
        }
      }else{
        if(this.imageCache.isMapixImagesEmpty()){
          // this.imageCache.setAllMapixImages();
        }

        this.assignNavbarValues();
      }
    }
  }

  //se puede reasignar a servicios diferentes cada observable
  assignNavbarValues() {
    var rolEncriptado = JSON.parse(localStorage.getItem("userRol"));
    var rolDecriptado = rolEncriptado.map((role) =>
      this.encriptionService.DecryptData(role)
    );
    this.setRolItem(rolDecriptado);
    this.authService.setRole(rolDecriptado);
    this.setViews(this.encriptionService.DecryptViews());
    
    var clienteEncriptado = JSON.parse(localStorage.getItem("listaClientes"));
    var clientesDecriptado = clienteEncriptado.map((client) =>
      this.encriptionService.DecryptData(client)
    );
    var clientes = clienteEncriptado == null ? [] : clientesDecriptado;
    this.setClientes(clientes);

    var clienteDisplayDecriptado = this.encriptionService.DecryptData(localStorage.getItem("ClienteSeleccionado"));
    var clienteDisplay = clienteDisplayDecriptado == null ? "Cargando...": clienteDisplayDecriptado;
    this.setClienteDisplay(clienteDisplay);
  }

  checkingURL() {
    this.sessionService.CheckURLSource();
    this.isMapix = this.sessionService.isMapix;
  }

  async dataCallback() {
    console.log("CallBackService - dataCallback");
    
    this.isCallBackActive = true;
   
    const [dataPermissions, viewPermissions, dataRol, dataClient, DeleteByUser, categories, categoriesImageUri, shownTutorial, systemNotification, mainMapGeoJson, urlSettings] = await Promise.all([
      firstValueFrom(this.permissionService.GetList().pipe(take(1))),
      firstValueFrom(this.viewService.getPermissionList().pipe(take(1))),
      firstValueFrom(this.UserConfigurationService.getUserRoles().pipe(take(1))),
      firstValueFrom(this.UserConfigurationService.GetByUserIdWithDefault().pipe(take(1))),
      firstValueFrom(this.signalUserService.DeleteByUser().pipe(take(1))),
      firstValueFrom(this.locationCategoriesService.getList().pipe(take(1))),
      firstValueFrom(this.azureStorageService.GetFolderFilesUrl(EnumFolderPaths.Location_Categories_Icons).pipe(take(1))),
      firstValueFrom(this.tutorialService.GetShownTutorials().pipe(take(1))),
      firstValueFrom(this.systemNotificationService.GetActive().pipe(take(1))),
      firstValueFrom(this.locationsService.GetLayerGPSGeoJson().pipe(take(1))),
      firstValueFrom(this.thirdPartySettingsService.getCitronellaImagesSettings().pipe(take(1))),
      // firstValueFrom(this.onWebCallback().pipe(take(1)))
    ]);
  
    try{
      this.dataPermissions(dataPermissions, viewPermissions);
    }catch(e){
      console.log(e);
    }
    if (dataRol.isSuccess) {
      const roles = dataRol.result.map(role => this.encriptionService.EncryptData(role));
      localStorage.setItem("userRol", JSON.stringify(roles));
    }
  
    if (dataClient.isSuccess) {
      this.UserConfigurationService.clientes = dataClient.result;
      const encriptedClients = dataClient.result.map(client => this.encriptionService.EncryptData(client));
      localStorage.setItem("listaClientes", JSON.stringify(encriptedClients));
      //localStorage.setItem("listaClientes", JSON.stringify(dataClient.result));
      if (localStorage.getItem("ClienteSeleccionado") == null || localStorage.getItem("ClienteSeleccionado") == "") {
        localStorage.setItem("ClienteSeleccionado", this.encriptionService.EncryptData(dataClient.result[0].customerName));
        localStorage.setItem("ClienteSeleccionadoId", this.encriptionService.EncryptData(dataClient.result[0].idCustomer));
      }
    }
  
    // Start Connection SignalR
    this.SignalUser = new SignalUser();
    this.signalRService.startConnection();
    // Wait for the SignalR ConnectionId to be assigned before subscribing.
    try {
      await this.waitForConnectionId(10000);
    
    } catch (e) {
      // If ConnectionId wasn't available in time, still attempt to subscribe once.
      console.warn('ConnectionId not available within timeout, attempting subscribe anyway.');
      this.subscribeSignalUser();
    }
  
    if (categories.isSuccess) {
      this.locationCategoriesService.categories = categories.result;
      localStorage.setItem("listaCategorias", JSON.stringify(categories.result));
    }
  
    // aquí se pueden agregar más llamadas a uris de azure storage
    var urlList: UrlSasDTO[] = [];
    if (categoriesImageUri.isSuccess) {
      urlList.push(...categoriesImageUri.result);
    }

    localStorage.setItem("UrlList", JSON.stringify(urlList));
    // this.imageCache.setAllMapixImages();


    var shownTutorials: string[] = [];
    if (shownTutorial.isSuccess) {
      shownTutorials.push(...shownTutorial.result);
    }
    localStorage.setItem("ShownTutorials", JSON.stringify(shownTutorials));

    if (systemNotification.isSuccess) {
      localStorage.setItem("SystemNotification", JSON.stringify(systemNotification.result));
    }

    if (mainMapGeoJson.isSuccess) {
      this.locationsMapService.mainGeoJsonData = JSON.parse(mainMapGeoJson.result);
    }

    this.notificationService.getActiveNotificationsCount();
    this.notificationService.getNotifications(1);

    if (this.enumCatalogService.enumCatalog == null || this.enumCatalogService.enumCatalog == undefined || this.enumCatalogService.enumCatalog.length == 0) {
      this.enumCatalogService.setEnumCatalogs();
    }

    if (urlSettings.isSuccess) {
      this.citronellaExternalAPIService.setUrlSettings(urlSettings.result.url, urlSettings.result.path, urlSettings.result.token);
    }


    this.isCallBackActive = false;
  }

  async dataCallbackOneCall(isRequiredUpdateClientId: boolean) {
    console.log("CallBackService - dataCallback - one call");
    
    this.isCallBackActive = true;

    const [onWebCallback] = await Promise.all([
      firstValueFrom(this.onWebCallback(isRequiredUpdateClientId).pipe(take(1)))
    ]);

    // console.log("onWebCallback", onWebCallback);


    const response = onWebCallback.result as WebCallbackDTO;
    if (onWebCallback.isSuccess && response) {
      try{
        var views = [];
        var permissions = [];
        if (response.permission_GetList) {
          console.log("permissions", response.permission_GetList);
          permissions = response.permission_GetList.map(permission => permission.shortName);
        }

        if (response.view_GetPermissionList) {
          views = response.view_GetPermissionList.map(view => view.name);
          var viewsEncriptado = this.encriptionService.EncryptData(response.view_GetPermissionList)
          localStorage.setItem("views", viewsEncriptado);
        }
        const  viewsPermissions = views.concat(permissions);
        const viewsPermissionsEncription = viewsPermissions.map((view) => {
          return this.encriptionService.EncryptData(view);
        });
        localStorage.setItem("permissions", JSON.stringify(viewsPermissionsEncription));
      }catch(e){
        console.log(e);
      }
      if (response.userConfiguration_GetUserRoles) {
        const roles = response.userConfiguration_GetUserRoles.map(role => this.encriptionService.EncryptData(role));
        localStorage.setItem("userRol", JSON.stringify(roles));
      }

      if (response.userConfiguration_GetByUserIdWithDefault) {
        this.UserConfigurationService.clientes = response.userConfiguration_GetByUserIdWithDefault;
        const encriptedClients = response.userConfiguration_GetByUserIdWithDefault.map(client => this.encriptionService.EncryptData(client));
        localStorage.setItem("listaClientes", JSON.stringify(encriptedClients));
        //localStorage.setItem("listaClientes", JSON.stringify(dataClient.result));
        if (localStorage.getItem("ClienteSeleccionado") == null || localStorage.getItem("ClienteSeleccionado") == "") {
          localStorage.setItem("ClienteSeleccionado", this.encriptionService.EncryptData(response.userConfiguration_GetByUserIdWithDefault[0].customerName));
          localStorage.setItem("ClienteSeleccionadoId", this.encriptionService.EncryptData(response.userConfiguration_GetByUserIdWithDefault[0].idCustomer));
        }
      }
    
      // Start Connection SignalR
      this.SignalUser = new SignalUser();
      this.signalRService.startConnection();
      // Wait for the SignalR ConnectionId to be assigned before subscribing.
      try {
        await this.waitForConnectionId(10000);
        this.subscribeSignalUser();
      } catch (e) {
        // If ConnectionId wasn't available in time, still attempt to subscribe once.
        console.warn('ConnectionId not available within timeout, attempting subscribe anyway.');
        this.subscribeSignalUser();
      }

      if (response.locationCategory_GetList) {
        this.locationCategoriesService.categories = response.locationCategory_GetList;
        localStorage.setItem("listaCategorias", JSON.stringify(response.locationCategory_GetList));
      }
    
      // aquí se pueden agregar más llamadas a uris de azure storage
      var urlList: UrlSasDTO[] = [];
      if (response.azureStorage_GetFolderFilesUrl) {
        urlList.push(...response.azureStorage_GetFolderFilesUrl);
      }
      console.log(urlList);

      localStorage.setItem("UrlList", JSON.stringify(urlList));
      // this.imageCache.setAllMapixImages();
  
  
      var shownTutorials: string[] = [];
      if (response.userTutorial_GetNamesListByUserId) {
        shownTutorials.push(...response.userTutorial_GetNamesListByUserId);
      }
      localStorage.setItem("ShownTutorials", JSON.stringify(shownTutorials));

      if (response.systemNotification_GetActive) {
        localStorage.setItem("SystemNotification", JSON.stringify(response.systemNotification_GetActive));
      }
  
      if (response.location_GetLayerGPSGeoJson) {
        this.locationsMapService.mainGeoJsonData = JSON.parse(response.location_GetLayerGPSGeoJson);
      }

      if (response.thirdPartySettings_GetCitronellaImagesSettings) {
        this.citronellaExternalAPIService.setUrlSettings(response.thirdPartySettings_GetCitronellaImagesSettings.url, response.thirdPartySettings_GetCitronellaImagesSettings.path, response.thirdPartySettings_GetCitronellaImagesSettings.token);
      }

      if (response.user) {
        localStorage.setItem("regularName", response.user.userName);
      }else{
        localStorage.setItem("regularName", "Elimm");
      }
      
  
      this.notificationService.getActiveNotificationsCount();
      this.notificationService.getNotifications(1);
  
      if (this.enumCatalogService.enumCatalog == null || this.enumCatalogService.enumCatalog == undefined || this.enumCatalogService.enumCatalog.length == 0) {
        this.enumCatalogService.setEnumCatalogs();
      }
  
      this.isCallBackActive = false;
    }else{
      this.isCallBackActive = false;
    }
    
  }

  dataPermissions(dataPermissions, viewPermissions) {
    
    var views = [];
      var permissions = [];
      if (dataPermissions.isSuccess) {
        console.log("permissions",dataPermissions.result);
        permissions = dataPermissions.result.map(permission => permission.shortName);
      }

      if (viewPermissions.isSuccess) {
        views = viewPermissions.result.map(view => view.name);
        // console.log("views",viewPermissions.result);
        var viewsEncriptado = this.encriptionService.EncryptData(viewPermissions.result)
        localStorage.setItem("views", viewsEncriptado);
      }
      const  viewsPermissions = views.concat(permissions);
      const viewsPermissionsEncription = viewsPermissions.map((view) => {
        return this.encriptionService.EncryptData(view);
      });
      localStorage.setItem("permissions", JSON.stringify(viewsPermissionsEncription));
  }

  subscribeSignalUser(){
    this.SignalUser.ConnectionId = this.signalRService.ConnectionId;
    console.log("SignalUser ConnectionId: ", this.SignalUser.ConnectionId);
    this.signalUserService.DeleteByUser().pipe(take(1)).subscribe(() => {
      console.log("Previous SignalUser deleted successfully.");
    });
    this.signalUserService.SubscribeGeneralSignalUserService(this.SignalUser);
    this.signalRService.ActivateListenerNewNotification();
  }

  /**
   * Polls until `signalRService.ConnectionId` is set or the timeout elapses.
   * Throws when the timeout is reached without a ConnectionId.
   */
  private async waitForConnectionId(timeoutMs: number = 10000, intervalMs: number = 200): Promise<void> {
    const start = Date.now();
    while (!this.signalRService.ConnectionId && (Date.now() - start) < timeoutMs) {
      await new Promise<void>((resolve) => setTimeout(() => resolve(), intervalMs));
    }
    if (!this.signalRService.ConnectionId) {
      throw new Error('ConnectionId not available within timeout');
    }
  }

  onWebCallback(isRequiredUpdateClientId: boolean){
    return this.callbackAPIService.OnWebCallback(isRequiredUpdateClientId);
  }

}
